import React from "react";
import {
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiLinkedin,
  FiChevronRight,
  FiMapPin,
  FiPhone,
} from "react-icons/fi";
import { Link } from "react-router-dom";

const HeaderTopBar = () => {
  return (
    <div className="header-top-bar">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-4 col-md-12 col-12">
            <div className="header-left"></div>
          </div>
          <div className="col-lg-8 col-md-12 col-12">
            <div className="header-right">
              <div className="address-content">
              <div className="btn-cont" style={{lineHeight:"initial",height:"initial",fontSize:"15px"}}>
              <FiMapPin />

              <a href="https://www.google.com/maps/dir/41.0279982,28.6848108/Yal%C4%B1,+No:,+Ba%C4%9Flar+Cd.+No:86,+%C3%87ukurova+Tower+%2F+34873+Kartal%2F%C4%B0stanbul/@40.9070334,28.6502856,11.25z/data=!4m9!4m8!1m1!4e1!1m5!1m1!1s0x14cac4a560bb95cb:0x7de3c324ef5aadb7!2m2!1d29.2209021!2d40.8980465?entry=ttu" 
              target="_blank" rel="noopener noreferrer" className="btnn newakefont" style={{fontWeight:200}}>
              Gebze / KOCAELİ
                <span className="line-2"></span>
                <span className="line-4"></span>
              </a>
            </div>

            <div className="btn-cont" style={{lineHeight:"initial",height:"initial",fontSize:"15px"}}>
            <FiPhone />

            <a href="tel:+902625027454" 
            target="_blank" rel="noopener noreferrer" className="btnn newakefont" style={{fontWeight:200}}>
            +90 262 502 74 54
              <span className="line-2"></span>
              <span className="line-4"></span>
            </a>
          </div>
          
              </div>
              <div className="social-icon-wrapper">
                <ul className="social-icon social-default icon-naked">
                  <li>
                    <Link to="twitter.com">
                      <FiFacebook />
                    </Link>
                  </li>
                  <li>
                    <Link to="twitter.com">
                      <FiTwitter />
                    </Link>
                  </li>
                  <li>
                    <Link to="instagram.com">
                      <FiInstagram />
                    </Link>
                  </li>
                  <li>
                    <Link to="linkdin.com">
                      <FiLinkedin />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderTopBar;
